import { render } from "./CockpitDisplay.vue?vue&type=template&id=42f0017e&scoped=true"
import script from "./CockpitDisplay.vue?vue&type=script&lang=js"
export * from "./CockpitDisplay.vue?vue&type=script&lang=js"

import "./CockpitDisplay.vue?vue&type=style&index=0&id=42f0017e&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f0017e"]])

export default __exports__